import { SegmentsProps, TSegmentItem } from './types';

export const getSizeClassName = (size: SegmentsProps['size'], cls: Record<string, string>) => {
    const sizes = {
        xl: cls.size_xl,
        l: cls.size_l,
        m: cls.size_m,
        s: cls.size_s,
        xs: cls.size_xs,
    };

    return sizes[size];
};

export const getInitialValue = (items: TSegmentItem[], initialValue: string | undefined) => {
    if (!initialValue) {
        return null;
    }

    const selectedItem = items.find((el) => el.value === initialValue);

    if (!selectedItem) {
        throw new Error('Указан несуществующий элемент в изначальном значении в компоненте segments');
    }

    return selectedItem.value;
};
